
import { defineComponent } from "vue";
import { TableEditingConfig } from "@/components/controls/catalogueGrid/tableEditingConfig";
import { TableSelectionConfig } from "@/components/controls/catalogueGrid/tableSelectionConfig";
import { TableDesignConfig } from "@/components/controls/catalogueGrid/tableDesignConfig";
import { TextColumnConfig } from "@/components/controls/catalogueGrid/columns/textColumnConfig";
import { IntegerColumnConfig } from "@/components/controls/catalogueGrid/columns/integerColumnConfig";
import CatalogueGrid from "@/components/controls/catalogueGrid/CatalogueGrid.vue";
import { DecimalColumnConfig } from "@/components/controls/catalogueGrid/columns/decimalColumnConfig";
import { TableExportConfig } from "@/components/controls/catalogueGrid/tableExportConfig";
import { TableImportConfig } from "@/components/controls/catalogueGrid/tableImportConfig";
import { CatalogueColumnConfig } from "@/components/controls/catalogueGrid/columns/catalogueColumnConfig";
import PackagesToLoadDialog from "./PackagesToLoadDialog.vue"
import store from "@/store";
import api from "@/services/api";

export default defineComponent({
  components: {
    CatalogueGrid,
    PackagesToLoadDialog,
  },
  props: {
    //показатель режима выбора
    selectMode: { required: false, type: Boolean, default: false },
    gridHeight: { required: false, type: String, default: null },
    //функция для получения выбранных элементов
    getSelectedData: { type: Function },
    //функция для вызова при изменении выбранных элементов
    changeSelectedData: { type: Function },
    //модель родительского элемента
    parentModel: { required: true },
    //идет расчет плана
    isCalculation: { required: false },
    //открыты ли настройки
    isSettingsOpen: { type: Object, required: true },
  },
  methods: {
    getScrollSettings() {
      const packageSettings = (store as any).state.packageSettings
        .packageSettings[this.parentModel.id];
      if (packageSettings) {
        this.designConfig.horizontalScroll = packageSettings.scroll;
      }
    },
    rememberScrollSettings(scroll: any) {
      const temp = {
        settings: {
          scroll: scroll,
        },
        index: this.parentModel.id,
      };
      store.dispatch("packageSettings/setPackageSettings", temp);
    },
    changeCompact() {
      this.$emit("change-compact", false);
    },
    openDialog() {
      let selectedRows = this.$refs.grid.dxGrid.getSelectedRowsData();
      if (selectedRows.length == 0) return;
      this.selectedRow = selectedRows[0];
      this.$refs.packagesToLoadDialog.show(true, this.selectedRow.packageCount);
    },
    async updatePackages(count: any) {
      this.$refs.grid.dxGrid.beginCustomLoading();
      await api.get(`PlanPackage/UpdatePackages`, {
        params: {
          count: this.selectedRow.packageCount,
          loadingCount: count,
          planId: this.parentModel.id,
          packageVolumeTypeId: this.selectedRow.packageVolumeTypeId,
          boardHeight: this.selectedRow.boardHeight,
          boardWidth: this.selectedRow.boardWidth,
          breed: this.selectedRow.breed,
          length: this.selectedRow.length,
        },
      });
      this.$refs.grid.dxGrid.refresh(true);
      this.$refs.grid.dxGrid.endCustomLoading();
    },
  },
  data() {
    return {
      selectedRow: null,
      // подробности работы custom summary см. на сервере в методе SetCustomSummary
      summaryConfig: {
        totalItems: [
          {
            name: "TotalSummary",
            showInColumn: "id",
            displayFormat: "Итог:",
            summaryType: "custom",
          },
          {
            name: "VolumeSummary",
            showInColumn: "volume",
            column: "volume",
            valueFormat: "#,##0.#",
            displayFormat: "{0} м³",
            summaryType: "sum",
          },
          {
            name: "WeightSummary",
            showInColumn: "weight",
            column: "weight",
            valueFormat: "#,##0.#",
            displayFormat: "{0} т.",
            summaryType: "sum",
          },
          {
            name: "PackageCountSummary",
            showInColumn: "packageCount",
            column: "packageCount",
            valueFormat: "#,##0.#",
            displayFormat: "{0} шт.",
            summaryType: "sum",
          },
        ],
      },

      editingConfig: new TableEditingConfig({
        allowDeleteAll: false,
        allowUpdating: false,
        allowAdding: false,
        allowDeleting: false,
        confirmDelete: false,
        allowDataFill: false,
        allowExport: true,
        allowImport: !this.isCalculation,
        allowClearFilter: true,
        allowCopy: false,
        allowDeleteMultipleRows: false,
        allowChangeScrollSettings: true,
        allowGrouping: false,
        allowResetSelectedRows: true,
        mode: "row",
        chooseColumns: false,
      }),
      selectModeEditingConfig: new TableEditingConfig({
        allowUpdating: false,
        allowAdding: false,
        allowDeleting: false,
        confirmDelete: false,
        allowDataFill: false,
        allowExport: false,
        allowDeleteMultipleRows: false,
      }),
      designConfig: new TableDesignConfig({
        popUpColumnsCount: 1,
        popUpWidth: "850px",
        heightScroll: "calc(100vh - 350px)",
        horizontalScroll: true,
      }),
      columns: [
        new IntegerColumnConfig({
          dataField: "id",
          caption: "ID",
        }),

        new TextColumnConfig({
          dataField: "cutSize",
          caption: "Сечение",
        }),

        new TextColumnConfig({
          dataField: "breed",
          caption: "Порода",
        }),

        new TextColumnConfig({
          dataField: "species",
          caption: "Сорт",
        }),

        new TextColumnConfig({
          dataField: "moisture",
          caption: "Влажность",
        }),

        new TextColumnConfig({
          dataField: "nomenclature",
          caption: "Номенклатура",
        }),

        new TextColumnConfig({
          dataField: "boardType",
          caption: "Тип доски",
        }),

        new DecimalColumnConfig({
          dataField: "volume",
          caption: "Объем (м³)",
          decimalPoints: 0,
        }),

        new DecimalColumnConfig({
          dataField: "weight",
          caption: "Вес (т)",
          decimalPoints: 0,
          hideFraction: true,
        }),

        new TextColumnConfig({
          dataField: "length",
          caption: "Длина (м)",
          alignment: "right",
        }),

        new IntegerColumnConfig({
          dataField: "packageCount",
          caption: "Кол-во пакетов",
        }),

        new IntegerColumnConfig({
          dataField: "loadingCount",
          caption: "Кол-во для погрузки",
        }),

        new CatalogueColumnConfig({
          dataField: "packageVolumeTypeDescription",
          caption: "Тип пакета",
          modelIdField: "packageVolumeTypeId",
          modelDescField: "packageVolumeTypeDescription",
          keyField: "id",
          displayField: "packageVolumeTypeDescription",
          displayDescField: "name",
          catalogueComponentName:
            "catalogues/PackageVolumeTypeCatalogue/PackageVolumeTypeCatalogue",
          descriptionColumnName: "packageVolumeTypeDescription",
          allowEmpty: true,
        }),
      ],
      importConfig: new TableImportConfig({
        progressMethodName: "importPlanPackageProgress",
        progressEventName: "importPlanPackageProgressEvent",
        messageEventName: "importPlanPackageMessageEvent",
      }),
      exportConfig: new TableExportConfig({
        progressMethodName: "exportPlanPackageProgress",
        progressEventName: "exportPlanPackageProgressEvent",
        messageEventName: "exportPlanPackageMessageEvent",
        exportFileName: "Пакеты-Opti-Loading",
      }),
      selectionConfig: new TableSelectionConfig({
        mode: "single",
        selectAllMode: "allPages",
        showCheckBoxesMode: "none",
      }),
      pageSizes: [10, 20, 50, 100],
      toolbarItems: this.isCalculation
        ? []
        : [
            {
              location: "before",
              widget: "dxButton",
              options: {
                text: "Пакеты не компактно",
                stylingMode: "outlined",
                onClick: this.changeCompact,
              },
            },
            {
              location: "before",
              widget: "dxButton",
              options: {
                icon: "edit",
                hint: "Изменить количество для погрузки",
                stylingMode: "text",
                onClick: this.openDialog,
              }
            }
          ],
    };
  },
  created() {
    this.getScrollSettings();
    if (this.selectMode) {
      this.editingConfig = this.selectModeEditingConfig;
    }
    if (this.gridHeight) {
      this.designConfig.height = this.gridHeight;
    }
  },
});
